import React, { useEffect, useRef, useState } from 'react';
import { ActionSheet, Button, Dialog, Space, Toast } from 'antd-mobile'
import {Trans} from "@lingui/react/macro";
import {DynamicIcon} from "lucide-react/dynamic";
import {MOBCOLORS} from "../../configs/AppConfig";
import { Dropdown } from 'antd';

export const ActionSheetContext=React.createContext(null)

export function useActionSheet(){
    return React.useContext(ActionSheetContext)
}

export function withActionSheet(Component) {
    return function WrappedComponent(props) {
        const actionSheetManager = useActionSheet();
        return <Component {...props} actionSheetManager={actionSheetManager} />;
    }
}

export default function ActionSheetProvider({children})
{
    const [extra, setExtra] = useState(null)
    const [actions, setActions] = useState([])
    const [isOpened, setIsOpened] = useState(false)

    const isOpenedRef=useRef(isOpened)
    useEffect(()=>{isOpenedRef.current=isOpened},[isOpened])

    const forceClose = async () => {
        return new Promise((resolve) => {
            setIsOpened(false)
            setTimeout(() => {
                resolve(true)
            }, 100)
        })
    }

    const formatActions=(_actions=[],toDropdown=false)=>{
        return _actions.map(a=>{

            let color="#000"
            if(a.success){
                color=MOBCOLORS.blue.color
            }
            if(a.warning){
                color=MOBCOLORS.orange.color
            }
            if(a.danger){
                color=MOBCOLORS.red.color
            }

            if(a.color && MOBCOLORS[a.color]){
                color=MOBCOLORS[a.color].color
            }

            a.text=(
                <div style={{display:"flex",flexDirection:"row",alignItems:"center",gap:10,color:color}} onClick={toDropdown?a.onClick:null}>
                    {a.icon &&(
                        <DynamicIcon name={a.icon} color={color} size={20} style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}/>
                    )}
                    <span>{a.text}</span>
                </div>
            )
            return a
        })
    }

    const toDropdown=(_actions=[])=>{
        const formatedActions=formatActions(_actions,true)
        const MENU=formatedActions.map((item,index)=>({label:item.text,key:index}))

        return ({ children })=>{
            return(
                <Dropdown trigger={['click']} menu={{items:MENU}}>
                    {children}
                </Dropdown>
            )
        }
    }

    const open=async (_actions=[],_extra=null)=>{
        if(isOpenedRef.current){
            await forceClose()
        }
        setExtra(_extra)
        setActions(formatActions(_actions))
        setIsOpened(true)
    }

    const confirm=async (title,callback=null)=>{
        if(isOpenedRef.current){
            await forceClose()
        }
        setExtra((<span style={{textAlign:"center",color:"#000"}}>{title}</span>))
        setActions([
            {
                danger:true,
                text:(<Trans>Oui, je suis sûr</Trans>),
                onClick:callback
            }
        ])
        setIsOpened(true)
    }

    const close=async ()=>{
        setIsOpened(false)
        setActions([])
        setExtra(false)
    }

    const bottomInset=window?.safeAreaInsets?.bottom || 0

    return(
        <ActionSheetContext.Provider value={{open:open,confirm:confirm,isOpened:isOpened,toDropdown:toDropdown}}>
            {children}

            <ActionSheet
                visible={isOpened}
                onClose={()=>close()}
                onMaskClick={()=>close()}
                actions={actions}
                extra={extra}
                destroyOnClose
                closeOnAction={true}
                cancelText={(<span style={{color:MOBCOLORS.blue.color}}><Trans>Annuler</Trans></span>)}
                style={{paddingBottom:bottomInset}}
            />
        </ActionSheetContext.Provider>
    )
}
